export default "__VITE_ASSET__DH3lUYua__"